<template>
  <div class="index2">
    <h1>医院注册</h1>
    <el-form
      :model="loginForm"
      :rules="rules"
      ref="ruleForm"
      label-width="0px"
      class="demo-ruleForm"
    >
      <el-form-item prop="hospitalPlace">
        <el-cascader
          placeholder="请选择医院所在地"
          v-model="loginForm.hospitalPlace"
          class="local"
          filterable
          :props="props"
          @change="changeda"
        ></el-cascader>
      </el-form-item>
      <el-form-item prop="hName">
        <div class="hospitalName">
          <el-select
            v-model="loginForm.hName"
            filterable
            :disabled="loginForm.hospitalPlace == ''"
            placeholder="请先选择医院所在地后再选择对应医院"
          >
            <el-option
              class="hospital"
              v-for="item in hsoptions"
              :key="item.hospital_name"
              :label="item.hospital_name"
              :value="item.hospital_name"
            >
            </el-option>
          </el-select>
        </div>
      </el-form-item>
      <el-form-item prop="username">
        <div class="user">
          <el-input
            v-model.trim="loginForm.username"
            class="username"
            placeholder="请输入称呼"
          ></el-input>

          <div class="sex">
            <el-radio v-model="loginForm.sex" label="1">先生</el-radio>
            <el-radio v-model="loginForm.sex" label="0">女士</el-radio>
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="phone">
        <el-input
          placeholder="请输入手机号"
          @blur="checkusername"
          prefix-icon="el-icon-user"
          clearable
          v-model.trim="loginForm.phone"
        >
        </el-input>
      </el-form-item>
      <el-form-item prop="password" class="tes_form">
        <el-input
          placeholder="请输入密码"
          prefix-icon="el-icon-lock"
          show-password
          v-model.trim="loginForm.password"
        >
        </el-input>
        <p class="text1">密码长度为6-20位，需同时包含大小写字母和数字</p>
      </el-form-item>
      <el-form-item prop="verfyCode">
        <div class="verify">
          <el-input
            placeholder="请输入验证码"
            prefix-icon="el-icon-lock"
            class="verify-input"
            show-password
            v-model.trim="loginForm.verfyCode"
          >
          </el-input>

          <div class="verify-code" @click="getVerifyImg()">
            <img :src="verifynum" alt="" />
          </div>
        </div>
      </el-form-item>
      <el-form-item prop="checkedNum">
        <div class="checkcode">
          <el-input
            placeholder="请输入短信验证码"
            prefix-icon="el-icon-message"
            class="input2"
            v-model.trim="loginForm.checkedNum"
          >
          </el-input>
          <span v-if="send" @click="fasong()">获取短信验证码</span>
          <span v-if="sende">{{ num }}秒后重新获取</span>
          <span v-if="sended" @click="refasong()">重新获取验证码</span>
        </div>
      </el-form-item>
      <el-form-item prop="checked">
        <div class="negotiate">
          <el-checkbox v-model="loginForm.checked" class="agree"
            >我已同意</el-checkbox
          >
          <span @click="toAgreement">《卫教云服务协议》</span>
        </div>
      </el-form-item>
    </el-form>

    <el-button type="primary" class="btn" @click="registerBtn('ruleForm')"
      >立即注册</el-button
    >

    <div class="tologin">
      <span>已有账号？</span>
      <span @click="toregist()">去登录></span>
    </div>
  </div>
</template>

<script>
import qs from "qs";
import md5 from "js-md5";
import area from "@/static/area";
import getquyu from "@/api/register";
import { ModifyPass, agreement,strongPass } from "@/utils/validata";

export default {
  data() {
    let that = this;
    return {
      loginForm: {
        hospitalPlace: "", // 医院所在地
        hName: "", // 选中的医院名称
        username: "", //用户名称
        sex: "1", // 性别
        phone: "", // 电话
        password: "", // 密码
        verfyCode: "", // 输入的验证码
        checkedNum: "", // 输入的短信验证码
        checked: false // 协议勾选框
      }, // 注册表单
      hsoptions: "", //医院列表
      sheng: 0,
      shi: 0,
      qu: 0,
      send: true,
      sende: false,
      sended: false,
      num: 60,
      timer: "",
      verifynum: "", //图片验证码
      guidcode: "",
      userData: {},
      options: [], //区域的列表
      props: {
        // label: "pname",
        // value: "id",
        lazy: true,
        async lazyLoad(node, resolve) {
          const { level } = node;
          if (level == 0) {
            await that.cascadeFn(); // 初始省的请求
            let arr = that.options.map(item => {
              return { value: item.id, label: item.pname };
            });
            resolve(arr); // 数据回显的回调
          }
          if (level == 1) {
            let { value } = node; // 点击当前获取到的ID
            that.cityCascadeFn({ parentId: value }).then(list2 => {
              let arr = list2.map(e => ({
                value: e.id,
                label: e.pname,
                leaf: true // 最后一个了
              }));
              resolve(arr);
            });
          }
        }
      },
      rules: {
        hospitalPlace: [
          {
            required: true,
            message: "请选择医院所在地",
            trigger: "change"
          }
        ],
        hName: [
          {
            required: true,
            message: "请选择医院",
            trigger: "change"
          }
        ],
        username: [{ required: true, message: "请输入称呼", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        password: [{ validator: strongPass(this), trigger: "blur" }],
        verfyCode: [
          { required: true, message: "请输入对应的验证码", trigger: "blur" }
        ],
        checkedNum: [
          { required: true, message: "请输入短信验证码", trigger: "blur" }
        ],
        checked: [{ validator: agreement(this), trigger: "blur" }]
      }
    };
  },
  methods: {
    // 选择医院
    async changeda(e) {
      // 这里是用来显示对应省的医院的
      this.loginForm.hName = "";
      let pamars = {
        cityId: e[1]
      };
      let res = await getquyu.getHospital(pamars);
      this.hsoptions = res.data.Data;
    },
    async checkusername() {
      //检验用户名情况
      let phonereg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/; //手机号正则式
      if (!phonereg.test(this.loginForm.phone)) {
        console.log("没通过校验");
        this.$message({
          message: "手机号格式不正确",
          type: "warning"
        });
        this.loginForm.phone = "";
        return;
      } else {
        let parmas = {
          phone: this.loginForm.phone
        };
        let resusername = await getquyu.checkUserName(parmas);
        if (resusername.data.Status !== 200) {
          this.$message({
            message: resusername.data.Data,
            type: "warning"
          });
          this.loginForm.phone = "";
        }
      }
    },
    // 立即注册
    registerBtn(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          let parmar = {
            hosName: this.loginForm.hName,
            password: md5(this.loginForm.password),
            phone: this.loginForm.phone,
            realName: this.loginForm.username,
            Sex: this.loginForm.sex,
            smsID: this.loginForm.checkedNum,
            type: 0
          };
          let registres = await getquyu.register(parmar);
          if (registres.data.Status == 200) {
            this.$message.success("注册成功！开始登录吧");
            this.$router.push({ path: "/login" });
          } else {
            this.$message.error(registres.data.Msg);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },

    // 获取短信验证码
    async fasong() {
      let phonereg = /^1([358][0-9]|4[579]|66|7[0135678]|9[89])[0-9]{8}$/; //手机号正则式
      if (!this.loginForm.verfyCode) {
        this.$message({
          message: "请输入验证码",
          type: "warning"
        });
      } else if (!phonereg.test(this.loginForm.phone)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "warning"
        });
      } else {
        //发送短信验证码前先校验一遍
        let parmas = {
          VerifyCode: this.loginForm.verfyCode,
          guidCode: this.guidcode,
          phone: this.loginForm.phone
        };
        let checkcoderes = await getquyu.checkVerifyCode(parmas);
        console.log(checkcoderes);
        if (checkcoderes.data.Status !== 200) {
          this.$message({
            message: checkcoderes.data.Msg,
            type: "warning"
          });
          this.getVerifyImg(); // 验证码校验失败后刷新验证码
          this.loginForm.verfyCode = "";
          return;
        } else {
          let parmas = {
            phone: this.loginForm.phone
          };
          let checkcoderes = await getquyu.sendSMS(parmas);
          console.log(checkcoderes);
          if (checkcoderes.data.Status === 200) {
            this.$message({
              message: "短信验证码发送成功",
              type: "success"
            });
          }
        }
        this.send = false;
        this.sende = true;
        this.timer = setInterval(() => {
          if (this.num !== 0) {
            this.num -= 1;
          } else {
            this.sende = false;
            this.sended = true;
            this.num = 60;
            clearInterval(this.timer);
          }
        }, 1000);

        // 发送短信验证码
      }
      return;
    },

    refasong() {
      this.send = false;
      this.sende = true;
      this.sended = false;
      this.timer = setInterval(() => {
        if (this.num !== 0) {
          this.num -= 1;
        } else {
          this.sende = false;
          this.sended = true;
          this.num = 60;
          clearInterval(this.timer);
        }
      }, 1000);

      // 发送短信验证码
    },
    // 跳转到登录
    toregist() {
      this.$router.push({ path: "/login" });
    },
    randomNum(min, max) {
      return Math.floor(Math.random() * (max - min) + min);
    },
    filebuffe(imgbuffe) {
      //文档二进制流转换为图片
      return (
        "data:image/png;base64," +
        btoa(
          new Uint8Array(imgbuffe.data).reduce(
            (data, byte) => data + String.fromCharCode(byte),
            ""
          )
        )
      );
    },
    // 跳转卫教云协议
    toAgreement() {
      let a = document.createElement("a");
      a.style.display = "none";
      a.href = "http://www.tibosi.com/protocol.html";
      a.setAttribute("target", "_blank");
      a.click();
    },
    async getVerifyImg() {
      //获取图片验证码
      let guidres = await getquyu.getguidCode();
      this.guidcode = guidres.data.Data.guidCode;
      let parmas = {
        guid: this.guidcode
      };
      let imgrescode = await getquyu.CreateVerificationCode(
        qs.stringify(parmas)
      );
      this.verifynum = this.filebuffe(imgrescode);
      console.log(this.verifynum);
    },

    // 省级
    async cascadeFn() {
      let parmas = {
        parentId: "100000"
      };
      const data = await getquyu.getSheng(parmas);
      if (data.data.Status == 200) {
        this.options = data.data.Data;
        // return data.data.Data
        this.options = this.options.filter(item => {
          return item.pname !== "钓鱼岛";
        });
      } else {
        this.$message.error(data.data);
      }
    },
    // 市级
    async cityCascadeFn(row) {
      const data = await getquyu.getSheng(row);
      if (data.status == 200) {
        return data.data.Data;
      } else {
        this.$message.error(data.data);
      }
    }
  },

  async created() {
    this.getVerifyImg();
    // this.cascadeFn();
    return;
    let parmas = {
      parentId: "100000"
    };
    let res = await getquyu.getSheng(parmas);
    for (let i = 0; i < res.data.Data.length; i++) {
      let parmas = {
        parentId: res.data.Data[i].id
      };
      let childrendata = await getquyu.getSheng(parmas);
      res.data.Data[i].children = childrendata.data.Data;
      if (res.data.Data[i].id == 900000) {
        res.data.Data[i].children = undefined;
      }
    }
    // res.data.Data.map((item) => {
    //     let parmas = {
    //       parentId: item.id,
    //     };
    //     let childrendata = getquyu.getSheng(parmas);
    //     childrendata.then((zitem) => {
    //       item.children = zitem.data.Data

    //     });
    //   });
    this.options = res.data.Data;
    // this.options.push(res.data.Data)
    console.log(this.options, 222);

    //  let a  = new Array(res.data.Data);
    //    this.$set(this.options,)
    // a.push(res.data.Data)
  }
};
</script>

<style lang="scss" scoped>
.index2 {
  width: 515px;
  height: 800px;
  background-color: rgb(255, 255, 255);
  padding-left: 32px;
  padding-right: 32px;
  border-radius: 25px;
  box-shadow: 0 0 48px #b2d6f8;
  position: absolute;
  top: 80px;
  left: 80px;
  h1 {
    //  background-color: royalblue;
    height: 50px;
    width: 120px;
    font-size: 30px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 42px;
    color: #333333;
    border-bottom: 4px solid #1890ff;
    margin: 20px auto;
  }
}

.local {
  width: 450px;
  margin-top: 30px;
}

.hospital {
  width: 450px;
  margin-top: 20px;
}

.hospitalName {
  display: flex;
  height: 40px;
  // margin-top: 20px;
  align-items: center;
  > :first-child {
    width: 450px;
  }
}

.user {
  display: flex;
  height: 40px;
  align-items: center;
  // justify-content: space-around;
  .username {
    width: 250px;
  }

  .sex {
    width: 140px;
    margin-left: 30px;
  }
}

.verify {
  display: flex;
  .verify-input {
    width: 330px;
  }
  .verify-code {
    width: 100px;
    height: 40px;
    background-color: #fff;
    text-align: center;
    line-height: 40px;
    cursor: pointer;
    font-weight: 600;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
    color: #1890ff;
    //  border-right: 1px solid #dcdfe6;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
  }
}

.checkcode {
  display: flex;
  .input2 {
    width: 330px;
    ::v-deep .el-input__inner {
      // border-right: none;
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
    }
  }
  span {
    background-color: rgb(255, 255, 255);
    width: 140px;
    height: 40px;
    font-size: 14px;
    text-align: center;
    line-height: 40px;
    color: #1890ff;
    font-weight: 600;
    cursor: pointer;
    font-family: "Microsoft Yahei";
    border-right: 1px solid #dcdfe6;
    border-top: 1px solid #dcdfe6;
    border-bottom: 1px solid #dcdfe6;
    //vertical-align:middle;这个垂直只在行内元素内生效，这里不生效的原因是弹性布局内的元素不能是行内元素
    &:hover {
      color: #2748ad;
    }
  }
}
.negotiate {
  margin-left: 20px;
  span {
    margin-left: 10px;
    font-size: 14px;
    font-weight: 600;
    color: #1890ff;
    cursor: pointer;
  }
  .agree {
    color: #999999;
  }
}
.btn {
  border-color: rgb(8, 70, 202);
  background-color: rgb(8, 70, 202);
  width: 450px;
  height: 50px;
  letter-spacing: 10px;
  font-weight: 900;
  font-family: "SimHei";
}
.tologin {
  // width: 450px;
  margin-top: 20px;
  font-weight: 600;
  font-family: "微软雅黑";
  transform: scale(0.9);
  color: #999999;
  span {
    &:nth-child(2) {
      cursor: pointer;
      color: #1890ff;
      font-size: 18px;
    }
  }
}
.text1{
  color: #999999;
  margin-left: 6px;
}
.tes_form{
  margin-bottom: 0 !important;
}
</style>
